import { Reducer } from 'redux';
import { UpdateExpiredVaccinesState, UpdateExpiredVaccinesStatus } from './UpdateExpiredVaccinesState';
import {
    CLIENT_FETCH_START,
    CLIENT_FETCH_SUCCESS,
    CLIENT_FETCH_ERROR,
    UPDATE_VACCINES_SAVE_START,
    UPDATE_VACCINES_SAVE_SUCCESS,
    UPDATE_VACCINES_SAVE_ERROR,
    UPDATE_VACCINES_CLEAR_SAVE_ERROR,
    UpdateVaccinesAction
} from 'actions/updateExpiredVaccines/UpdateExpiredVaccinesActionTypes';

const initialState: UpdateExpiredVaccinesState = {
    clientExpiredVaccines: null,
    status: UpdateExpiredVaccinesStatus.Initial,
    loading: false,
    error: false,
    saving: false,
    saveError: undefined
};

export const UpdateExpiredVaccinesReducer: Reducer<UpdateExpiredVaccinesState, UpdateVaccinesAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case CLIENT_FETCH_START:
            return {
                ...state,
                status: UpdateExpiredVaccinesStatus.Getting,
                loading: true
            };
        case CLIENT_FETCH_SUCCESS:
            return {
                ...state,
                clientExpiredVaccines: action.payload.clientExpiredVaccines,
                status: UpdateExpiredVaccinesStatus.GettingSuccess,
                loading: false
            };
        case CLIENT_FETCH_ERROR:
            return {
                ...state,
                clientExpiredVaccines: null,
                status: UpdateExpiredVaccinesStatus.Error,
                loading: false,
                error: true
            };
        case UPDATE_VACCINES_SAVE_START:
            // `loading` stays untouched: it gates the full-page spinner, which
            // would unmount the form and discard the user's pending edits.
            return {
                ...state,
                status: UpdateExpiredVaccinesStatus.Getting,
                saving: true,
                saveError: undefined
            };
        case UPDATE_VACCINES_SAVE_SUCCESS:
            return {
                ...state,
                status: UpdateExpiredVaccinesStatus.SaveSuccess,
                saving: false
            };
        case UPDATE_VACCINES_SAVE_ERROR:
            // A failed save is a recoverable form error: keep the loaded client
            // and leave `error` alone so the page does not fall back to the
            // "Client Not Found" state.
            return {
                ...state,
                status: UpdateExpiredVaccinesStatus.Error,
                saving: false,
                saveError: action.payload.variant ? { variant: action.payload.variant } : undefined
            };
        case UPDATE_VACCINES_CLEAR_SAVE_ERROR:
            return {
                ...state,
                saveError: undefined
            };
        default:
            return state;
    }
};
